<template>

    <div :class="isAgentGroup?'p-20px bg-white':'sales_ratio-wrap p-20px bg-white'" > 
        <div class="title_wrap">
            <div class="title mb-15px"> {{selAgent.reportType=='TODAY'?$t('dashBoard.cAgtDBWeeklySales.todaySales'):selAgent.reportType=='THISMONTH'?$t('dashBoard.cAgtDBWeeklySales.monthlySales'):selAgent.reportType=='THISWEEK'?$t('dashBoard.cAgtDBWeeklySales.weeklySales'):$t('dashBoard.cAgtDBWeeklySales.sales')}}</div>

        </div>
        <div class="hike_n_drop_wrap">
            <div class="d-flex">
                <div>
                    
                    <div  class="wrap">
                        <div class="top"><span class="text-muted"> {{selAgent.reportType=='TODAY'?$t('dashBoard.cAgtDBWeeklySales.today'):selAgent.reportType=='THISMONTH'?$t('dashBoard.cAgtDBWeeklySales.thisMonth'):selAgent.reportType=='THISWEEK'?$t('dashBoard.cAgtDBWeeklySales.thisWeek'):$t('dashBoard.cAgtDBWeeklySales.thisPeriod')}} </span></div>
                        <div class="bottom">
                            <h3 v-if="chartValues.thisWeekSum!=0" class="text-info d-flex">{{chartValues.currency+' '}}{{chartValues.thisWeekSum | formatNumber(chartValues.currency)}} 
                                
                                <!-- <span
                                    class="d-flex pl-5px pb-3px">

                                    <img v-if="chartValues && chartValues.percentOfThisWeek>=0"
                                    src="@imgPath/img/svg/icons/green-up-arrow.svg" alt=""
                                    class="sm-icon-dash">
                                    <img v-if="chartValues && chartValues.percentOfThisWeek<0"
                                    src="@imgPath/img/svg/icons/red-down-arrow.svg" alt=""
                                    class="sm-icon-dash">
                                    <div
                                    class="text-muted f-12px">{{chartValues.percentOfThisWeek}}</div></span> -->
                                    </h3>
                                    <h3 v-else class="text-info d-flex">{{chartValues.currency?chartValues.currency:''+' '}} 0 </h3>
                        </div>
                    </div>
                </div>
                <div class="ml-4">
                    <div  class="wrap">
                        <div class="top"><span class="text-muted"> {{selAgent.reportType=='TODAY'?$t('dashBoard.cAgtDBWeeklySales.yesterday'):selAgent.reportType=='THISMONTH'?$t('dashBoard.cAgtDBWeeklySales.lastMonth'):selAgent.reportType=='THISWEEK'?$t('dashBoard.cAgtDBWeeklySales.lastWeek'):$t('dashBoard.cAgtDBWeeklySales.lastPeriod')}} </span></div>
                        <div class="bottom">
                            <h3 v-if="chartValues.lastWeekSum!=0" class="text-muted d-flex "> {{chartValues.currency+' '}}{{chartValues.lastWeekSum| formatNumber(chartValues.currency)}} 
                                <!-- <span
                                    class="d-flex pl-5px pb-3px"><img
                                    src="/img/red-down-arrow.20669387.svg" alt=""
                                    class="sm-icon-dash"><div
                                    class="text-muted f-12px">18.6</div></span> -->
                                    </h3>
                                    <h3 v-else class="text-muted d-flex "> {{chartValues.currency?chartValues.currency:''+' '}} 0 </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grap-wrap"> 
            <div class="sales ct-charts mt-5" v-if="chartValues.dataSets.length!=0">
                <!-- {{chartValues.chartLabel}} -->
                <CChartLineTwoSets :defaultDatasets="chartValues.dataSets" :chartLabels="chartValues.chartLabel" background-color="#137eff"/>



            </div>
        </div>

        <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
      </CAlert> 
    </div>


<!--    <CCard v-if="dataSets.length!=0">-->
<!--        <CCardBody>-->

<!--            <CChartLineTwoSets :defaultDatasets="dataSets" :chartLabels="chartLabel"/>-->
<!--        </CCardBody>-->
<!--    </CCard>-->


    <!-- <CCard >
<CCardBody>

      <CChartLineTwoSets />
    </CCardBody>
    </CCard> -->
</template>
<script>
    import Logger from "../../../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../../../router/index";
    import apib2bSysWeeklySales from "./../../../../services/apib2bSysWeeklySales";
    import CChartLineTwoSets from "../../../chart/CChartLineTwoSets"
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME, AGENT_DB_REPORT_TYPE} from "../../../../util/constants";
    import BaseConfiguration from "../../../../config/base.js";
    import SERVICE_URL from "../../../../config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import {handleJWT, getErrorAlertValue} from "../../../../util/util";

    export default {
        name: COMPONENT_NAME.C_AGT_DB_WEEKLY_SALES,

        data() {
            return {
                chartValues :{
                    dataSets: [],
                    chartLabel: [],
                    thisWeekSum : 0,
                    lastWeekSum:0,
                    currency:"",
                    
                },
                alertValue: null,                
            }
        },
        components: {
            CChartLineTwoSets
        },
        props:{
            selAgent:{
            type: Object,
            default: null
        },
        isAgentGroup: {
            type:Boolean,
            default: false
        }
    //     status:{
    //        type: String,
    //        default:null
    //    },
        },
        // computed: {
        //     ...mapGetters("sSysLogin", {
        //         ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
        //     }),
        // },
        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                // if (this.ADMIN_SIGNIN_RES) {
                    let weeklySalesRes = await this.getWeeklySales();
                    if(this.selAgent)
                    this.chartValues = this.toGetDataSets(weeklySalesRes,this.selAgent.reportType)
                // }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGT_DB_WEEKLY_SALES,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        methods: {

            showAlert(val) {
                this.$emit("showAlert", val);
            },

            toGetDataSets(pWeeklySalesRes,pReportType) {
                let retValue = {
                    dataSets: [],
                    chartLabel: [],
                    thisWeekSum : 0,
                    lastWeekSum:0,
                    currency:null,
                    //percentOfThisWeek:0
                };
                let dataSetsValue = [
                    {
                        label: pReportType==AGENT_DB_REPORT_TYPE.THISMONTH?'This Month':pReportType==AGENT_DB_REPORT_TYPE.CUSTOM?
                                'This Period':pReportType==AGENT_DB_REPORT_TYPE.THISWEEK?'This Week':'Today',
                        //backgroundColor: 'rgb(228,102,81,0.9)',
                          backgroundColor: '#f6fcff',
                                borderColor: "#137eff",
                                pointBackgroundColor: "#137eff",//getColor(this.pointHoverColor),
          pointHoverBackgroundColor: "#137eff",//getColor(this.pointHoverColor),
                        data: []
                    },
                    {
                        label: pReportType==AGENT_DB_REPORT_TYPE.THISMONTH?'Last Month':pReportType==AGENT_DB_REPORT_TYPE.CUSTOM?
                                'Last Period':pReportType==AGENT_DB_REPORT_TYPE.THISWEEK?'Last Week':'Yesterday',
                        //backgroundColor: 'rgb(0,216,255,0.9)',
                        backgroundColor: '#fafdff',
                                borderColor: "#c9d9ea",
                                pointBackgroundColor: "#c9d9ea",//getColor(this.pointHoverColor),
          pointHoverBackgroundColor: "#c9d9ea",//getColor(this.pointHoverColor),
                        data: []
                    }
                ];
                let dateValues = [];

                try {
                    // let sumOfCurWeek = 0, sumOfLastWeek =0, currency=null, percentOfCurWeek=0, salesDiff = 0;
                    let dateFormat = null;
                    let sumOfCurWeek = 0, sumOfLastWeek =0, currency=null;//, percentOfCurWeek=0, salesDiff = 0;
                    if (BaseConfiguration.isDebug) console.log("toGetDataSets");
                    if(pReportType==AGENT_DB_REPORT_TYPE.THISMONTH || pReportType==AGENT_DB_REPORT_TYPE.CUSTOM) {
                        dateFormat = "DD MMM";
                         }else if(pReportType==AGENT_DB_REPORT_TYPE.THISWEEK){
                             dateFormat = "ddd";
                         }else if(pReportType==AGENT_DB_REPORT_TYPE.TODAY){
                             dateFormat = "HH";
                         }
                    if (pWeeklySalesRes) {
                        if (pWeeklySalesRes.currentperiod) {                            
                            for (let i = 0; i < pWeeklySalesRes.currentperiod.length; i++) {
                                
                                dateValues.push(this.$options.filters.formatDate(new Date(pWeeklySalesRes.currentperiod[i].date), dateFormat));
                               

                                dataSetsValue[0].data.push(pWeeklySalesRes.currentperiod[i].amount);
                                sumOfCurWeek += pWeeklySalesRes.currentperiod[i].amount;
                                if(!currency)
                                    currency = pWeeklySalesRes.currentperiod[i].currency;
                            }
                        }                        
                        if (pWeeklySalesRes.pastperiod) {
                            for (let i = 0; i < pWeeklySalesRes.pastperiod.length; i++) {
                                dateValues.push(this.$options.filters.formatDate(new Date(pWeeklySalesRes.pastperiod[i].date), dateFormat));
                                dataSetsValue[1].data.push(pWeeklySalesRes.pastperiod[i].amount);
                                sumOfLastWeek+=pWeeklySalesRes.pastperiod[i].amount;
                            }
                        }
                    //     salesDiff = (sumOfCurWeek/pWeeklySalesRes.currentperiod.length)-(sumOfLastWeek/pWeeklySalesRes.pastperiod.length);
                    //     percentOfCurWeek = percentOfCurWeek = salesDiff/((sumOfLastWeek/pWeeklySalesRes.pastperiod.length)*100);
                    // }
                        // if(sumOfCurWeek!=0 && sumOfLastWeek!=0){
                      /*  if(sumOfCurWeek!=0 && sumOfLastWeek!=0){
                            salesDiff = (sumOfCurWeek/pWeeklySalesRes.currentperiod.length)-(sumOfLastWeek/pWeeklySalesRes.pastperiod.length);
                        }else if(sumOfCurWeek!=0 && sumOfLastWeek==0){
                           salesDiff = (sumOfCurWeek/pWeeklySalesRes.currentperiod.length); 
                        }
                        else if(sumOfLastWeek!=0 && sumOfCurWeek==0){
                           salesDiff = (sumOfLastWeek/pWeeklySalesRes.pastperiod.length); 
                        }*/

                       
                       /* if(salesDiff && sumOfLastWeek!=0) {
                        percentOfCurWeek = salesDiff/((sumOfLastWeek/pWeeklySalesRes.pastperiod.length)*100);
                        }
                        else{
                          percentOfCurWeek = salesDiff;  
                        }*/
                    
                    retValue.dataSets = dataSetsValue;
                    
                    retValue.chartLabel = [...new Set(dateValues)];
                    retValue.thisWeekSum = sumOfCurWeek;
                    retValue.lastWeekSum = sumOfLastWeek;
                    retValue.currency = currency;
                    /*if(percentOfCurWeek!=0) {
                    retValue.percentOfThisWeek=percentOfCurWeek.toFixed(2);
                    }
                
                    }*/
                    // }
                    }
                    //this.chartLabel = [...new Set(dateValues)];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_AGT_DB_WEEKLY_SALES,
                        "error in toGetDataSets",
                        err.toString(),
                        "toGetDataSets",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            async getWeeklySales() {
                if (BaseConfiguration.isDebug) console.log("getWeeklySales");
                let returnValue;
                try {
                    let weeklySalesReq = apib2bSysWeeklySales.buildRequest(this.selAgent); //constant

                    if (weeklySalesReq != null) {
                        let weeklySalesRes = await apib2bSysWeeklySales.getResponse(
                            weeklySalesReq
                        );
                        if (VALIDATE_SUCCESS_RES(weeklySalesRes)) {
                            returnValue = weeklySalesRes.data.data;

                        } else {
                            let error = getErrorMessage(weeklySalesRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_AGT_DB_WEEKLY_SALES,
                        "error in  getWeeklySales",
                        err.toString(),
                        "getWeeklySales()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
        }
    }

</script>